<template>
  <div class="row">
    <div class="col-md-7">
      <p>{{ 'logo_upload' | translate }}<br><small
        class="text-warning">{{ 'logo_format' | translate }}</small></p>
      <div class="form-group">
        <button class="btn btn-default" @click="$refs.fileInput.click()">{{ 'file_select' | translate }}</button>
        <label class="ml-5">
          {{ src }}
        </label>
        <input style="visibility:hidden" ref="fileInput" id="fileInput" type="file" @change="onFileChange">
      </div>
    </div>
    <div class="col-md-5">
      <img class="img-responsive" :src="logo || '/static/img/no-image.png' " alt="Photo">
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoreLogoUploader',
  data () {
    return {
      image: {},
      logo: false,
      src: ''
    }
  },
  mounted ()  {
    this.getLogo()
  },
  methods: {
    getLogo () {
      API.get('directsales/logo')
        .then(res => {
          this.logo = res.data.url || false
        })
    },
    onFileChange (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.src = files[0].name
      this.createImage(files[0])
    },
    createImage (file) {
      let reader = new window.FileReader()
      reader.onload = (e) => {
        this.image = {
          title: file.title,
          subtitle: '',
          file: e.target.result,
          name: file.name.split('.')[0]
        }
        this.upload()
      }
      reader.readAsDataURL(file)
    },
    upload () {
      this.image.file = this.image.file.split(',')[1]
      let alert
      API.post('directsales/logo', {image: this.image.file, name: this.image.name})
        .then(response => {
            let alert = {
              dismiss: 4,
              type: 'success',
              message: `logo uploaded successfully`
            }
            this.$store.commit('pushAlert', alert)
            this.getLogo()
        })
        .catch(error => {
          alert = {
            dismiss: 4,
            type: 'danger',
            message: error.response.data.message,
            icon: 'icon fa fa-ban',
            show: true
          }
          this.$store.commit('pushAlert', alert)
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/StoreLogoUploader.vue